import { render, staticRenderFns } from "./FarmStats.vue?vue&type=template&id=0d3fb245&"
import script from "./FarmStats.vue?vue&type=script&lang=js&"
export * from "./FarmStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports